// @ts-nocheck
document.addEventListener('DOMContentLoaded', function () {

  var categoryRoutes = {
    jackets: '/collections/jackets',
    blazers: '/collections/blazers',
    waistcoats: '/collections/waistcoats'
  };
  var initialUrl = new URL(window.location.href);
  var legacyCategory = initialUrl.searchParams.get('category');
  if (initialUrl.pathname === '/collections/all' && Object.prototype.hasOwnProperty.call(categoryRoutes, legacyCategory)) {
    var targetUrl = new URL(categoryRoutes[legacyCategory], window.location.origin);
    ['size', 'colour', 'material', 'reversible', 'availability', 'price', 'sort', 'q'].forEach(function (key) {
      var value = initialUrl.searchParams.get(key);
      if (value) targetUrl.searchParams.set(key, value);
    });
    window.location.replace(targetUrl.toString());
    return;
  }

  /* ============================================================
     BANNER ANIMATIONS
  ============================================================ */
  var bannerImg     = document.querySelector('.dori-banner-img-js');
  var bannerContent = document.querySelector('.dori-banner-content-js');

  if (bannerImg) {
    // Trigger scale-in as soon as image loads
    if (bannerImg.complete) {
      setTimeout(function () { bannerImg.classList.add('dori-loaded'); }, 80);
    } else {
      bannerImg.addEventListener('load', function () {
        setTimeout(function () { bannerImg.classList.add('dori-loaded'); }, 80);
      });
    }
  }

  if (bannerContent) {
    var bcObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dori-visible');
          bcObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    bcObs.observe(bannerContent);
  }

  /* ============================================================
     MOBILE DRAWER
  ============================================================ */
  var mobileToggle = document.querySelector('.dori-mobile-toggle-js');
  var mobileDrawer = document.querySelector('.dori-mobile-drawer-js');
  var mobileClose  = document.querySelector('.dori-mobile-close-js');

  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', function () {
      mobileDrawer.classList.toggle('is-open');
    });
  }
  if (mobileClose && mobileDrawer) {
    mobileClose.addEventListener('click', function () {
      mobileDrawer.classList.remove('is-open');
    });
  }

  /* ============================================================
     DROPDOWNS
  ============================================================ */
  function closeAllDropdowns() {
    document.querySelectorAll('.dori-dropdown-js').forEach(function (d) {
      d.classList.remove('is-open');
    });
  }

  document.querySelectorAll('.dori-dropdown-js').forEach(function (dropdown) {
    var toggle = dropdown.querySelector('.dori-dropdown__toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var wasOpen = dropdown.classList.contains('is-open');
      closeAllDropdowns();
      if (!wasOpen) dropdown.classList.add('is-open');
    });
  });

  document.addEventListener('click', closeAllDropdowns);

  // Keyboard access: Escape closes any open dropdown
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDropdowns();
  });

  /* ============================================================
     STATE
  ============================================================ */
  var state = {
    size         : 'all',
    colour       : 'all',
    material     : 'all',
    reversible   : 'all',
    availability : 'all',
    price        : 'all',
    sort         : 'featured',
    q            : ''
  };

  /* Label maps for filter values (used by query, chips and toggle labels) */
  var SIZE_LABELS       = { 's': 'S', 'm': 'M', 'l': 'L', 'xl': 'XL', 'xxl': 'XXL' };
  var COLOUR_LABELS     = { 'ivory': 'Ivory', 'azure': 'Azure', 'scarlet': 'Scarlet', 'sand': 'Sand', 'espresso': 'Espresso' };
  var MATERIAL_LABELS   = { 'silk': 'Silk', 'cotton': 'Cotton', 'linen': 'Linen', 'wool': 'Wool' };
  var REVERSIBLE_LABELS = { 'yes': 'Reversible', 'no': 'Non-reversible' };
  var AVAILABILITY_LABELS = { 'in-stock': 'In Stock', 'sold-out': 'Sold Out', 'made-to-order': 'Made to Order' };
  var PRICE_LABELS      = { 'under5k': 'Under ₹5,000', '5k-10k': '₹5,000 – ₹10,000', 'above10k': 'Above ₹10,000' };
  var SORT_LABELS       = { 'featured': 'Featured', 'newest': 'Newest', 'price-asc': 'Price: Low to High', 'price-desc': 'Price: High to Low' };

  // Restore from URL on load
  var qs = new URLSearchParams(window.location.search);
  state.size         = qs.get('size')         || 'all';
  state.colour       = qs.get('colour')       || 'all';
  state.material     = qs.get('material')     || 'all';
  state.reversible   = qs.get('reversible')   || 'all';
  state.availability = qs.get('availability') || 'all';
  state.price        = qs.get('price')        || 'all';
  state.sort         = qs.get('sort')         || 'featured';
  state.q            = qs.get('q')            || '';

  /* ============================================================
     SERVER-RENDERED PRODUCT FILTERS
  ============================================================ */
  function updateResultsCount(count) {
    var row = document.querySelector('.dori-results-js');
    if (row) row.textContent = 'Showing ' + count + ' styles';
  }

  function applyCollectionFilters(s) {
    var container = document.getElementById('dori-products-grid');
    if (!container) return;

    var cards = Array.prototype.slice.call(container.querySelectorAll('.dori-card'));
    var visibleCards = [];
    var query = (s.q || '').trim().toLowerCase();

    cards.forEach(function (card) {
      var tags = (card.dataset.tags || '').split('|').filter(Boolean);
      var title = card.dataset.title || '';
      var description = card.dataset.description || '';
      var type = card.dataset.type || '';
      var matches = true;
      var price = Number.parseFloat(card.dataset.price || '0');
      var available = card.dataset.available === 'true';
      var hasTag = function (value) { return tags.indexOf(value.toLowerCase()) !== -1; };

      if (s.size !== 'all' && SIZE_LABELS[s.size] && !hasTag(SIZE_LABELS[s.size])) matches = false;
      if (s.colour !== 'all' && COLOUR_LABELS[s.colour] && !hasTag(COLOUR_LABELS[s.colour])) matches = false;
      if (s.material !== 'all' && MATERIAL_LABELS[s.material] && !hasTag(MATERIAL_LABELS[s.material])) matches = false;
      if (s.reversible === 'yes' && !hasTag('reversible')) matches = false;
      if (s.reversible === 'no' && hasTag('reversible')) matches = false;
      if (s.availability === 'in-stock' && !available) matches = false;
      if (s.availability === 'sold-out' && available) matches = false;
      if (s.availability === 'made-to-order' && !hasTag('made to order') && title.indexOf('espresso command') === -1) matches = false;
      if (s.price === 'under5k' && price >= 5000) matches = false;
      if (s.price === '5k-10k' && (price < 5000 || price > 10000)) matches = false;
      if (s.price === 'above10k' && price <= 10000) matches = false;
      if (query && [title, description, tags.join(' '), type].join(' ').indexOf(query) === -1) matches = false;

      card.style.display = matches ? '' : 'none';
      if (matches) visibleCards.push(card);
    });

    visibleCards.sort(function (a, b) {
      var priceA = Number.parseFloat(a.dataset.price || '0');
      var priceB = Number.parseFloat(b.dataset.price || '0');
      if (s.sort === 'newest') return Number(b.dataset.createdAt || 0) - Number(a.dataset.createdAt || 0);
      if (s.sort === 'price-asc') return priceA - priceB;
      if (s.sort === 'price-desc') return priceB - priceA;
      return Number(a.dataset.featuredIndex || 0) - Number(b.dataset.featuredIndex || 0);
    });

    visibleCards.forEach(function (card) { container.appendChild(card); });
    updateResultsCount(visibleCards.length);

    var emptyState = container.querySelector('.dori-empty');
    if (!visibleCards.length && !emptyState) {
      emptyState = document.createElement('div');
      emptyState.className = 'dori-empty';
      emptyState.innerHTML =
        '<p class="dori-empty__heading">No styles match these filters.</p>' +
        '<p class="dori-empty__body">Clear one or more filters to see this collection.</p>' +
        '<button type="button" class="dori-empty__btn dori-empty-clear-js">Clear Filters</button>';
      container.appendChild(emptyState);
      var clearButton = emptyState.querySelector('.dori-empty-clear-js');
      if (clearButton) clearButton.addEventListener('click', clearAllFilters);
    } else if (visibleCards.length && emptyState) {
      emptyState.remove();
    }
  }

  /* ============================================================
     UPDATE UI ACTIVE STATES
  ============================================================ */
  // Generic filter config: state key → { items selector, data attr, label element, name, label map }
  var FILTER_DEFS = [
    { key: 'size',         itemSel: '.dori-size-item',         attr: 'size',         labelSel: '.dori-size-label',         name: 'Size',         labels: SIZE_LABELS },
    { key: 'colour',       itemSel: '.dori-colour-item',       attr: 'colour',       labelSel: '.dori-colour-label',       name: 'Colour',       labels: COLOUR_LABELS },
    { key: 'material',     itemSel: '.dori-material-item',     attr: 'material',     labelSel: '.dori-material-label',     name: 'Material',     labels: MATERIAL_LABELS },
    { key: 'reversible',   itemSel: '.dori-reversible-item',   attr: 'reversible',   labelSel: '.dori-reversible-label',   name: 'Reversible',   labels: REVERSIBLE_LABELS },
    { key: 'availability', itemSel: '.dori-availability-item', attr: 'availability', labelSel: '.dori-availability-label', name: 'Availability', labels: AVAILABILITY_LABELS },
    { key: 'price',        itemSel: '.dori-price-item',        attr: 'price',        labelSel: '.dori-price-label',        name: 'Price',        labels: PRICE_LABELS }
  ];

  function clearAllFilters() {
    state.size         = 'all';
    state.colour       = 'all';
    state.material     = 'all';
    state.reversible   = 'all';
    state.availability = 'all';
    state.price        = 'all';
    state.q            = '';
    document.querySelectorAll('.dori-search-js').forEach(function (input) { input.value = ''; });
    applyFilters();
  }

  function updateActiveStates(s) {
    var sort = s.sort     || 'featured';

    // Mobile price
    document.querySelectorAll('.dori-mobile-price').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.price === (s.price || 'all'));
    });

    // Mobile generic filter tags (Size / Colour / Material / Reversible / Availability)
    document.querySelectorAll('.dori-mobile-filter').forEach(function (btn) {
      btn.classList.toggle('is-active', (s[btn.dataset.filter] || 'all') === btn.dataset.value);
    });

    // Mobile sort tags
    document.querySelectorAll('.dori-mobile-sort').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.sort === sort);
    });

    // Generic dropdown filters (Size / Colour / Material / Reversible / Availability / Price)
    FILTER_DEFS.forEach(function (f) {
      var value = s[f.key] || 'all';

      document.querySelectorAll(f.itemSel).forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset[f.attr] === value);
      });

      var labelEl = document.querySelector(f.labelSel);
      if (labelEl) labelEl.textContent = (value !== 'all' && f.labels[value]) ? f.labels[value] : f.name;
    });

    // Sort dropdown items
    document.querySelectorAll('.dori-sort-item').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn.dataset.sort === sort);
    });

    // Sort toggle label
    var sortLabel = document.querySelector('.dori-sort-label');
    if (sortLabel) sortLabel.textContent = SORT_LABELS[sort] || 'Featured';

    // Active filter chips bar
    var activeBar  = document.querySelector('.dori-active-bar-js');
    var chipsWrap  = document.querySelector('.dori-chips-js');
    if (!activeBar || !chipsWrap) return;

    var chipSvg = ' <svg width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    var chips = '';

    FILTER_DEFS.forEach(function (f) {
      var value = s[f.key] || 'all';
      if (value !== 'all' && f.labels[value]) {
        chips +=
          '<button class="dori-chip dori-chip-remove" data-type="' + f.key + '">' +
            f.labels[value] + chipSvg +
          '</button>';
      }
    });

    chipsWrap.innerHTML = chips;
    activeBar.classList.toggle('is-visible', chips !== '');

    // Bind remove chip buttons
    chipsWrap.querySelectorAll('.dori-chip-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var type = btn.dataset.type;
        if (state.hasOwnProperty(type)) state[type] = 'all';
        applyFilters();
      });
    });
  }

  /* ============================================================
     APPLY FILTERS (main orchestrator)
  ============================================================ */
  function applyFilters(pushHistory) {
    if (pushHistory === undefined) pushHistory = true;

    // Update browser URL
    var url = new URL(window.location.href);
    url.searchParams.delete('category');
    if (state.size !== 'all')         url.searchParams.set('size',         state.size);
    else                               url.searchParams.delete('size');
    if (state.colour !== 'all')       url.searchParams.set('colour',       state.colour);
    else                               url.searchParams.delete('colour');
    if (state.material !== 'all')     url.searchParams.set('material',     state.material);
    else                               url.searchParams.delete('material');
    if (state.reversible !== 'all')   url.searchParams.set('reversible',   state.reversible);
    else                               url.searchParams.delete('reversible');
    if (state.availability !== 'all') url.searchParams.set('availability', state.availability);
    else                               url.searchParams.delete('availability');
    if (state.price !== 'all')        url.searchParams.set('price',        state.price);
    else                               url.searchParams.delete('price');
    if (state.sort !== 'featured')    url.searchParams.set('sort',         state.sort);
    else                               url.searchParams.delete('sort');
    if (state.q)                      url.searchParams.set('q',            state.q);
    else                               url.searchParams.delete('q');

    if (pushHistory) window.history.pushState({ state: state }, '', url.toString());

    closeAllDropdowns();
    updateActiveStates(state);

    applyCollectionFilters(state);
  }

  /* ============================================================
     BIND UI EVENTS
  ============================================================ */

  // Generic dropdown filter items (Size / Colour / Material / Reversible / Availability / Price)
  FILTER_DEFS.forEach(function (f) {
    document.querySelectorAll(f.itemSel).forEach(function (btn) {
      btn.addEventListener('click', function () {
        state[f.key] = btn.dataset[f.attr] || 'all';
        applyFilters();
      });
    });
  });

  // Sort dropdown items
  document.querySelectorAll('.dori-sort-item').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.sort = btn.dataset.sort || 'featured';
      applyFilters();
    });
  });

  // Clear all filters (active bar button)
  var clearAllBtn = document.querySelector('.dori-clear-all-js');
  if (clearAllBtn) clearAllBtn.addEventListener('click', clearAllFilters);

  // Mobile price
  document.querySelectorAll('.dori-mobile-price').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.price = btn.dataset.price || 'all';
      applyFilters();
    });
  });

  // Search — debounced; keeps desktop bar and mobile drawer inputs in sync
  var searchInputs = document.querySelectorAll('.dori-search-js');
  var searchTimer = null;
  searchInputs.forEach(function (input) {
    input.value = state.q;
    input.addEventListener('input', function () {
      searchInputs.forEach(function (other) {
        if (other !== input) other.value = input.value;
      });
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        state.q = input.value.trim();
        applyFilters();
      }, 450);
    });
  });

  // Mobile generic filter tags (Size / Colour / Material / Reversible / Availability)
  document.querySelectorAll('.dori-mobile-filter').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state[btn.dataset.filter] = btn.dataset.value || 'all';
      applyFilters();
    });
  });

  // Mobile sort tags
  document.querySelectorAll('.dori-mobile-sort').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.sort = btn.dataset.sort || 'featured';
      applyFilters();
    });
  });

  // Browser back / forward
  window.addEventListener('popstate', function (e) {
    var p = new URLSearchParams(window.location.search);
    state.size         = p.get('size')         || 'all';
    state.colour       = p.get('colour')       || 'all';
    state.material     = p.get('material')     || 'all';
    state.reversible   = p.get('reversible')   || 'all';
    state.availability = p.get('availability') || 'all';
    state.price        = p.get('price')        || 'all';
    state.sort         = p.get('sort')         || 'featured';
    state.q            = p.get('q')            || '';
    document.querySelectorAll('.dori-search-js').forEach(function (input) { input.value = state.q; });
    applyFilters(false);
  });

  /* ============================================================
     INITIAL LOAD
  ============================================================ */
  applyFilters(false);

});

